module.exports = __webpack_public_path__ + "static/media/errorIcon.c4b671f1.svg";